import { Dialog, DialogTitle, Divider, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, 
  TableContainer, TableHead, TablePagination, TableRow,ToggleButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import BillingService from "../../../Services/MasterBilling/BillingService";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import Home from "../../home/Home";
import Snacbar from "../../Snacbar";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: theme.palette.common.black,
    padding: theme.spacing(0.5),
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  // border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
}));


function Billcharge() {
  const mystyle = {
    border: " 1px solid black",fontFamily: 'Times New Roman',
    width: "12rem",
  };
  const mystyle1 = {
    fontWeight: "bolder",fontFamily: 'Times New Roman',
    color: "red",
  };
  const [bill, setbill] = useState({
    oldChargnem: '',
    chrgtype: '',
    chrgname: '',
    hsn: '',
  });

  const [saveDsa, setSaveDsa] = useState(false);
  const [updateDsa, setUpdateDsa] = useState(true);
  const [deleteDsa, setDeleteDsa] = useState(true);

  const [Deletes, setDelete] = useState(false);
  const [save, setSave] = useState(false);
  const [update, setUpdate] = useState(false);

  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('');
  const [message, setMessage] = useState('');

  const [error, setError] = useState({
    chrgtype: false, chargename: false, hsn: false
  })

  const [details, setDetails] = useState([]);
  const [filterdetails, setfilterdetails] = useState([]);

  const [chargDetails, setChrgDetails] = useState([]);

  const chrgtypehandlechange = (e) => {
    setbill({ ...bill, chrgtype: e.target.value });
  };
  const chrgnamehandlechange = (e) => {
    setbill({ ...bill, chrgname: e.target.value });
  };
  const hsnhandlechange = (e) => {
    setbill({ ...bill, hsn: e.target.value });
  };
  //icon
  const deleteicon = () => {
    return <DeleteOutlineRoundedIcon style={{color:'red'}}/>
  }
  //getData
  const getData = async () => {
    BillingService.getCharge().then((res) => {
      setDetails(res.data);
      setfilterdetails(res.data);
    })
  }

  const getDrpData = () => {
    BillingService.getChargeType().then((res) => {
      setChrgDetails(res.data);
    })
  }

  useEffect(() => {
    const getData = async () => {
      BillingService.getCharge().then((res) => {
        setDetails(res.data);
        setfilterdetails(res.data);
      })
    }
    getDrpData();
    getData();
  }, []);

  //handleClose/open
  const handleClose = () => {
    setOpen(false);
  }

  //tableClick
  const EditBillCharge = (item) => {
    setSaveDsa(true);
    setUpdateDsa(false);
    setDeleteDsa(false);
    setDelete(false);
    setSave(false);
    setUpdate(false);
    setbill({ ...bill, oldChargnem: item.chargeName, chrgname: item.chargeName, chrgtype: item.chargeTypeName, hsn: item.hsnCode });
    setError({ ...error, chrgtype: false, chargename: false, hsn: false });
  }

  //clickevent
  const validetion = () => {
    if (bill.chrgname !== '') {
      if (bill.chrgtype !== '') {
        if (bill.hsn !== '') {
          return true;
        } else {
          document.getElementById('hsn').focus();
          setError({ ...error, hsn: true })
          setOpen(true); setSeverity('warning'); setMessage('Please Enter a hsn...!!');
        }
      } else {
        document.getElementById('chargeType').focus();
        setError({ ...error, chrgtype: true })
        setOpen(true); setSeverity('warning'); setMessage('Please Enter a ChargeType...!!');
      }
    } else {
      document.getElementById('chargeName').focus();
      setError({ ...error, chargename: true })
      setOpen(true); setSeverity('warning'); setMessage('Please Enter a ChargeName...!!');
    }
    return false;
  }

  const SaveDetails = () => {
    if (validetion() === true) {
      setSaveDsa(true);
      setSave(true);
      let details = { chargeName: bill.chrgname, chargeTypeName: bill.chrgtype, hsnCode: bill.hsn }
      BillingService.insertCharge(details).then((res) => {
        const message = res.data.message;
        if (message.toString(details) === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage(message);
        } else {
          setOpen(true); setSeverity('error'); setMessage('Insertion Failed');
        } refresh();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
      })
    }
  }

  const updateDetails = () => {
    if (validetion() === true) {
      setUpdateDsa(true);
      setUpdate(true);
      let details = { oldChargeName: bill.oldChargnem, chargeName: bill.chrgname, chargeTypeName: bill.chrgtype, hsnCode: bill.hsn }
      BillingService.updateCharge(details).then((res) => {
        const message = res.data.message;
        if (message.toString(details) === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage(message);
        } else {
          setOpen(true); setSeverity('error'); setMessage('Updation Failed');
        } refresh();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
      })
    }
  }
  const DeleteDetails = () => {
    setDeleteDsa(true);
    setDelete(true);
    setalertopen(true)
  }
  const refresh = () => {
    setPage(0)
    setSaveDsa(false);
    setUpdateDsa(true);
    setDeleteDsa(true);
    setDelete(false);
    setSave(false);
    setUpdate(false);
    setbill({ ...bill, oldChargnem: '', chrgname: '', chrgtype: '', hsn: '' });
    setError({ ...error, chrgtype: false, chargename: false, hsn: false });
    getData();
  }
  const chargetypeSerach = () => {
    return <input className="searchBoxes" onChange={(e) => { ChargetypeOnChng(e.target.value) }} placeholder={"Search"} />
  }
  const chargeNameSerach = () => {
    return <input className="searchBoxes" onChange={(e) => { ChargeNameOnChng(e.target.value) }} placeholder={"Search"} />
  }
  const ChargetypeOnChng = (SearchedVal) => {
    const FilterValues = details.filter((trns) => {
      return trns.chargeTypeName.toString().toLowerCase().includes(SearchedVal.toLowerCase())
    })
    if (SearchedVal.length < 1) {
      setfilterdetails(details)
    } else {
      setfilterdetails(FilterValues)
    }
  }
  const ChargeNameOnChng = (SearchedVal) => {
    const FilterValues = details.filter((trns) => {
      return trns.chargeName.toString().toLowerCase().includes(SearchedVal.toLowerCase())
    })
    if (SearchedVal.length < 1) {
      setfilterdetails(details)
    } else {
      setfilterdetails(FilterValues)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
   //alertbox
   const [alertopen, setalertopen] = useState(false);

   const alertonClickOpen = (item) => {
     setalertopen(true)
     setbill({ ...bill, oldChargnem: item.chargeName })
   }
 
   const alertNoOnClick = () => {
     refresh();
     setalertopen(false)
   }
 
   const alertYesOnClick = () => {
     BillingService.deleteCharge(bill.oldChargnem).then((res) => {
      const message = res.data.message;
      if (message.toString(details) === 'SUCCESS') {
        setOpen(true); setSeverity('success'); setMessage(message);
      } else {
        setOpen(true); setSeverity('error'); setMessage('Failed TO Delete');
      } refresh();
    }).catch(error => {
      setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
    });
    setalertopen(false)
   }
   const navigate = useNavigate();
   const BackBotton =()=>{
     navigate('/Itemtype');
   }
   const ForwordBotton =()=>{
     navigate('/qutationImporter');
   }
  return (
    <div>
       <Dialog open={alertopen}>
        <DialogTitle>
          <center><h6 style={{ fontFamily: 'Times New Roman'}}>ARE YOU SURE,</h6></center>
          <h6 style={{ fontFamily: 'Times New Roman'}}>YOU WANT TO DELETE ?</h6>
          <Divider color="#FDA228" sx={{ height: 2 }} />
        </DialogTitle>
        <div className="form-inline p-1">
          <center><Button variant="danger" className="p-1 mb-2 mr-1" style={{ width: '50px',fontFamily: 'Times New Roman'}} onClick={alertYesOnClick}>Yes</Button>&nbsp;
            <Button variant="success" className="p-1 mb-2 " style={{ width: '50px' }} onClick={alertNoOnClick}>No</Button></center>
        </div>
      </Dialog>
      <Home /><Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
      <div style={{ paddingLeft: "80px" }}>
      <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
        <ItemPap>
          <Grid container>
            <Grid xs={4} style={{ marginTop: "1rem" }}>
            <Row>
                <Col xs={1}>
          {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small"> <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px',marginLeft:'5px' }} /> </ToggleButton> */}
            </Col>
            <Col xs={11}>
              <Typography color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"}style={{ fontFamily: 'Times New Roman'}}>
                Bill Charge Details Entry
              </Typography>
              </Col>
              </Row>
              <hr></hr>
              <Row className="mt-3">
                <Col xs={4}>
                  <label style={mystyle1}>ChargeType</label>
                </Col>
                <Col xs={8}>
                  <Form.Select size="sm" type="text" style={mystyle} value={bill.chrgtype}
                    onChange={chrgtypehandlechange} required isInvalid={error.chrgtype} id='chargeType'>
                    <option value={''}></option>
                    {chargDetails.map((item) => (
                      <option value={item.chargeTypeName}>{item.chargeTypeName}</option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={4}>
                  <label style={mystyle1}>ChargeName</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" style={mystyle} value={bill.chrgname}
                    onChange={chrgnamehandlechange} required isInvalid={error.chargename} id='chargeName' />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={4}>
                  <label style={mystyle1}>HSN Code</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle} value={bill.hsn}
                    onChange={hsnhandlechange} required isInvalid={error.hsn} id='hsn' />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col lg={1}></Col>
                <Col lg={10}>
                  <Button style={{ fontFamily: 'Times New Roman'}} variant="success" size="sm" disabled={saveDsa} onClick={SaveDetails}>
                    {save ? 'processing..' : 'Save'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}} variant="primary" size="sm" disabled={updateDsa} onClick={updateDetails}>
                    {update ? 'Processing..' : 'Update'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}} variant="danger" size="sm" disabled={deleteDsa} onClick={DeleteDetails}>
                    {Deletes ? 'Processing..' : 'Delete'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}} variant="secondary" size="sm" onClick={refresh}>
                    Refresh
                  </Button>
                </Col>
                <Col lg={1}></Col>
              </Row>
            </Grid>

            <Grid xs={8} style={{ marginTop: "1rem" }}>
              <ItemPap1>
              <Row>
                  <Col xs={11}>
                <Typography color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"}style={{ fontFamily: 'Times New Roman'}}>
                  Existing Bill Charge Details
                </Typography>
                </Col>
                <Col xs={1}>
                        {/* <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small"> 
                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px'}} /></ToggleButton>  */}
                  </Col>
                </Row>
                <TableContainer sx={{ height: 360 }} style={{ marginTop: "1px" }}>
                  <Table stickyHeader className="table table-bordered">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell>SlNo</StyledTableCell>
                        <StyledTableCell>ChargeType {chargetypeSerach()}</StyledTableCell>
                        <StyledTableCell>Bill ChargeName {chargeNameSerach()}</StyledTableCell>
                        <StyledTableCell>HSN Code</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center' }}>Actions</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                    {filterdetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((item, index) => (
                        <StyledTableRow hover key={item.chargeName} onClick={() => EditBillCharge(item)}>
                          <StyledTableCell style={{textAlign: 'center'}}>{item.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{textAlign: 'center'}}>{item.chargeTypeName}</StyledTableCell>
                          <StyledTableCell style={{textAlign: 'center'}}>{item.chargeName}</StyledTableCell>
                          <StyledTableCell style={{textAlign: 'center'}}>{item.hsnCode}</StyledTableCell>
                          <StyledTableCell style={{textAlign: 'center'}}><lu onClick={() => alertonClickOpen(item)}>{deleteicon()}</lu></StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  showFirstButton
                  showLastButton
                  component='div'
                  count={filterdetails.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onChangeRowsPerpage={handleChangeRowsPerPage}
                />
              </ItemPap1>
            </Grid>
          </Grid>
        </ItemPap>
      </div>
    </div>
  );
}

export default Billcharge;